import React from "react";
import { Container, Row } from "react-bootstrap";

import timesheetStructuresService from "presentation/services/timesheet-structures";
import timesheetStructureItemsService from "presentation/services/timesheet-structure-items";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import TimesheetStructureForm from 'presentation/pages/timesheet-structures/elements/form';

import {
  mountItems
} from 'presentation/pages/timesheet-structures/functions/timesheet-structure-items';


class TimesheetStructureEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      totalItems: 1,
      rawDaysOfWeek: [],
      timesheetStructureItems: [],
      actionLoading: false,
      error: false,
      message: '',
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {
    await timesheetStructureItemsService.search({ timesheetStructureId: [id] }).then(async (resultItems) => {
      await timesheetStructuresService.findById(id).then((result) => {

        var orderedItems = resultItems.sort((a, b) => a.order - b.order);
        let structureItems = [];

        for (let i = 0; i < orderedItems.length; i++) {
          let structureItem = orderedItems[i];
          structureItem.key = i + 1;
          structureItems.push(structureItem);
        }

        let totalItems = structureItems.length > 0 ? structureItems.length : 1;

        let rawDaysOfWeek = result.daysOfWeek.split(',').map((e) => parseInt(e));
        this.setState({ form: result, rawDaysOfWeek: rawDaysOfWeek, timesheetStructureItems: structureItems, totalItems: totalItems, loading: false }, () => mountItems(this));

      });


    });

  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  render() {
    let { loading, error, message, actionLoading, form } = this.state;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <TimesheetStructureForm
                loading={loading}
                error={error}
                form={form}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default TimesheetStructureEdit;
